import { Prompt, PromptProps } from 'react-router';
import { connect } from 'react-redux';
import * as appUI from '../../../modules/uis/app';
import RootState from '../../../modules/rootState';

const mapStateToProps = (state: RootState): PromptProps => ({
    message: 'Your changes may not be saved yet. Do you want to leave this page?',
    when: appUI.selectors.getHasDirtyData(state),
});

export default connect(mapStateToProps)(Prompt);


// WEBPACK FOOTER //
// ./src/components/shared/dirty-data/DirtyMonitor.container.tsx